import { useParams } from "react-router-dom";

const Navbar = () => {
  const { token } = useParams();
  const path = window.location.pathname;

  const links = [
    { href: `/${token}/home`,         label: '💳 Transactions',  key: '/home' },
    { href: `/${token}/smsReceive`,   label: '📩 SMS Reçus',     key: '/smsReceive' },
    { href: `/${token}/myPasserelle`, label: '📡 Passerelles',   key: '/myPasserelle' },
    { href: `/${token}/apis`,         label: '🔌 APIs',          key: '/apis' },
  ];

  return (
    <nav style={{ display: 'flex', gap: '0' }}>
      {links.map((link) => {
        const isActive = link.key && path.includes(link.key);
        return (
          <a
            key={link.key}
            href={link.href || '#'}
            className={`nav-link${isActive ? ' active-link' : ''}`}
          >
            {link.label}
          </a>
        );
      })}
    </nav>
  );
};

export default Navbar;
